unit uLockerDataStore_JSON;

interface

uses
  System.SysUtils, System.Classes, WEBLib.JSON, WEBLib.WebCtrls, Web, WEBLib.REST,
  uLockerDataStore;

type
  TLockerDataStore_JSON = class(TLockerDataStore)
  private
    FServiceURL: string;
    FLockerID: string;


    [async] function ExecuteRequest(const AAction: string; AData: TJSONObject = nil): TJSXMLHttpRequest; async;

  public
    constructor Create(const AServiceURL: string; const ALockerID: string);
    [async] function Add(AData: TJSONObject): Boolean; async; override;
    [async] function Read(): TLockerData; async; override;
    [async] function Update(AData: TJSONObject): Boolean; async; override;
    [async] function Delete(): Boolean; async; override;
    [async] function AddOrUpdate(AData: TJSONObject): Boolean; async; override;
    function GetLockerID: string; override;
    property LockerID: string read GetLockerID;
  end;

implementation

const
  API_KEY = 'DcbnsIsvm2aOJPeOahI7AQXpa6z1AyRX';

//==========================================================
constructor TLockerDataStore_JSON.Create(const AServiceURL: string; const ALockerID: string);
//==========================================================
begin
  inherited Create;
  FServiceURL := AServiceURL;
  FLockerID := ALockerID;
end;

//==========================================================
function TLockerDataStore_JSON.GetLockerID: string;
//==========================================================
begin
  Result := FLockerID;
end;

//==========================================================
function TLockerDataStore_JSON.ExecuteRequest(const AAction: string; AData: TJSONObject = nil): TJSXMLHttpRequest;
//==========================================================
  function post_arg( const _nm, _val : string ) : string;
  begin
    Result := '"'+_nm+'":"'+_val+'"';
  end;
  //---------------------------
var
  Request: THttpRequest;
  PostData: string;
  pd1, pd2, pd3 : string;
begin
  Request := THttpRequest.Create(nil);
  try
    Request.URL := FServiceURL;
    Request.Command := httpPOST;
    pd1 := post_arg( 'action',   AAction );
    pd2 := post_arg( 'lockerID', FLockerID );
    pd3 := post_arg( 'apiKey',   API_KEY );

    if Assigned(AData) then
      PostData := Format( '{%s,%s,%s,"data":%s}', [pd1, pd2, pd3, AData.ToJSON] )
    else
      PostData := Format( '{%s,%s,%s}', [pd1, pd2, pd3] );

    Request.PostData := PostData;
    Result := await(TJSXMLHttpRequest, Request.Perform);
  finally
    Request.Free;
  end;
end;
//==========================================================
[async]
function TLockerDataStore_JSON.Add(AData: TJSONObject): Boolean; async;
//==========================================================
var
  req: TJSXMLHttpRequest;
begin
  req := await(TJSXMLHttpRequest, ExecuteRequest('add', AData));
  Result := (req.status = 200);
end;

//==========================================================
[async]
function TLockerDataStore_JSON.Read(): TLockerData; async;
//==========================================================
var
  req: TJSXMLHttpRequest;
  Response: TJSONObject;
begin
  Result := nil;
  req := await(TJSXMLHttpRequest, ExecuteRequest('read'));

  Response := TJSONObject.ParseJSONValue(string(req.response)) as TJSONObject;
  if Assigned(Response) then
  begin
    Result := TLockerData.Create;
    Result.LockerID := FLockerID;
    Result.JsonData := Response;
  end;
end;

//==========================================================
[async]
function TLockerDataStore_JSON.Update(AData: TJSONObject): Boolean; async;
//==========================================================
var
  req: TJSXMLHttpRequest;
begin
  req := await(TJSXMLHttpRequest, ExecuteRequest('update', AData));
  Result := (req.status = 200);
end;

//==========================================================
[async]
function TLockerDataStore_JSON.Delete(): Boolean; async;
//==========================================================
var
  req: TJSXMLHttpRequest;
begin
  req := await(TJSXMLHttpRequest, ExecuteRequest('delete'));
  Result := (req.status = 200);
end;

//==========================================================
[async]
function TLockerDataStore_JSON.AddOrUpdate(AData: TJSONObject): Boolean; async;
//==========================================================
var
  req: TJSXMLHttpRequest;
begin
  req := await(TJSXMLHttpRequest, ExecuteRequest('addorupdate', AData));
  Result := (req.status = 200);
end;

end.
